/*
  Keeps fenced code meta (`title="..."`, `showLineNumbers`, `{1,3}`) alive.

  Zudoku runs rehype-raw before its Shiki plugin. rehype-raw rebuilds every
  element and drops `data.meta`, so titles and line numbers never reach the
  code block. Shiki also reads `properties.metastring`, and properties do
  survive rehype-raw, so we copy the meta there before the tree leaves remark.
*/

type Node = {
  type: string;
  meta?: string | null;
  data?: { hProperties?: Record<string, unknown> };
  children?: Node[];
};

const visit = (node: Node) => {
  if (node.type === "code" && node.meta) {
    node.data ??= {};
    node.data.hProperties = { ...node.data.hProperties, metastring: node.meta };
  }
  node.children?.forEach(visit);
};

export const remarkCodeMeta = () => (tree: Node) => {
  visit(tree);
};
